export function isIOSSafari(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false
  }

  const ua = navigator.userAgent || ''
  const isIOS = /iPad|iPhone|iPod/.test(ua)

  // Real iOS Safari UAs include both `Safari` and a `Version/` token.
  // Many other iOS browsers include `Safari` in their UA string but add
  // their own identifiers (CriOS, FxiOS, EdgiOS, OPiOS, DuckDuckGo, GSA, etc.).
  // Require the Safari signature and explicitly exclude known non‑Safari iOS UAs.
  const hasSafariSignature = /Safari/i.test(ua) && /Version\//i.test(ua)
  const excludedBrowsers =
    /(CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo|GSA|Chrome|Chromium)/i

  return isIOS && hasSafariSignature && !excludedBrowsers.test(ua)
}
